var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "col-right" }, [
              _c("div", { staticClass: "company-top" }, [
                _c("div", { staticClass: "company-notice" }, [
                  _c("p", [
                    _vm._v(" 南通市中医院EMC 3.8T SSD维保等采购项目成交公告 "),
                    _c("span", { staticClass: "a-href-look" }, [
                      _c("a", { attrs: { href: "" } }, [_vm._v("查看原文")]),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "company-tag" },
                  [
                    _c("el-tag", { attrs: { size: "small" } }, [
                      _vm._v("标签一"),
                    ]),
                    _c(
                      "el-tag",
                      {
                        staticStyle: { "margin-left": "8px" },
                        attrs: { size: "small", type: "success" },
                      },
                      [_vm._v("标签二")]
                    ),
                    _c(
                      "el-tag",
                      {
                        staticStyle: { "margin-left": "8px" },
                        attrs: { size: "small", type: "info" },
                      },
                      [_vm._v("标签三")]
                    ),
                    _c(
                      "el-tag",
                      {
                        staticStyle: { "margin-left": "8px" },
                        attrs: { size: "small", type: "warning" },
                      },
                      [_vm._v("标签四")]
                    ),
                    _c(
                      "el-tag",
                      {
                        staticStyle: { "margin-left": "8px" },
                        attrs: { size: "small", type: "danger" },
                      },
                      [_vm._v("标签五")]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "company-info" }, [
                  _c("div", [
                    _vm._v("项目编号："),
                    _c("span", [_vm._v("1009-2241HOLLY02YNB")]),
                  ]),
                  _c("div", [
                    _vm._v("招标单位："),
                    _c("span", { staticStyle: { color: "#56b1fe" } }, [
                      _vm._v("南通市中医院"),
                    ]),
                  ]),
                  _c("div", [
                    _vm._v("招标单位："),
                    _c("span", { staticStyle: { color: "#56b1fe" } }, [
                      _vm._v("江苏弘业国际技术工程有限公司"),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "company-time" }, [
                  _c("div", { staticClass: "time" }, [
                    _vm._v("发布时间："),
                    _c("span", [_vm._v("2022-01-27")]),
                  ]),
                  _c("div", { staticClass: "money" }, [
                    _vm._v("中标金额："),
                    _c("span", [_vm._v("39.4508万元")]),
                  ]),
                ]),
                _c("div", { staticClass: "company-money" }, [
                  _c("div", { staticClass: "relation-way" }, [
                    _vm._v("联系方式"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "tenderee-phone" },
                    [
                      _vm._v("招标人 "),
                      _c("span", [_vm._v("吴晓峰 ")]),
                      _c("span", [_vm._v(" 13723339399 ")]),
                      _c("el-button", { attrs: { type: "text" } }, [
                        _vm._v("更多"),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("view-number", {
            ref: "vNumber",
            attrs: {
              baseData: _vm.numberData,
              companyStatus: _vm.companyStatus,
            },
            on: { lookNumber: _vm.lookNumberInner },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }